export default __webpack_public_path__ + "static/media/SD-mrithyunjaya-homam-img.2b63be29.png";